import React from "react";
import styled from "styled-components";
import { AlertNotification, H2, LabeledInput, Text, fontFamilies, colors } from "@commonsku/styles";
import ConfirmPopup from "../../ConfirmPopup";

const FullWidthInput = styled.div`
    &&& {
        width: 100%;

        > div,
        input {
            width: 100%;
            box-sizing: border-box;
        }
    }
`;

interface CatalogBulkDeletePopupProps {
    count: number;
    deleteInput: string;
    onDeleteInputChange: (value: string) => void;
    deleting?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const CatalogBulkDeletePopup = ({
    count,
    deleteInput,
    onDeleteInputChange,
    deleting = false,
    onCancel,
    onConfirm,
}: CatalogBulkDeletePopupProps) => (
    <ConfirmPopup
        cancelLabel="Cancel"
        confirmLabel={`Delete ${count} product${count !== 1 ? "s" : ""}`}
        confirmVariant="error"
        confirmDisabled={deleteInput.toLowerCase() !== "delete"}
        confirmLoading={deleting}
        onClose={onCancel}
        onConfirm={onConfirm}
    >
        <>
            <H2 style={{ margin: 0 }}>
                Delete {count} product{count !== 1 ? "s" : ""}
            </H2>
            <AlertNotification alertType="error">
                <Text style={{ fontFamily: fontFamilies.skuFontRegular, color: colors.errors[80] }}>
                    {count !== 1 ? "These" : "The"} {count} product{count !== 1 ? "s" : ""} will be permanently deleted and their External SKUs will become available to reuse. This can&apos;t be undone.
                </Text>
            </AlertNotification>
            <FullWidthInput>
                <LabeledInput
                    label="Type DELETE here"
                    value={deleteInput}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        onDeleteInputChange(e.target.value)
                    }
                    placeholder="Type here"
                    autoFocus
                />
            </FullWidthInput>
        </>
    </ConfirmPopup>
);
